import Skeleton from 'react-loading-skeleton';
import { cx } from '@emotion/css';

export const AutomaticSearchLoadingState = ({ className }) => (
  <div className={cx(className, 'flex flex-col desktop:flex-row')} data-testid="toolAutomaticSearchSectionLoading">
    <div className="flex-1">
      <Skeleton className="h-[96px] desktop:max-w-[330px]" />
    </div>
    <div className="mt-6 flex flex-1 flex-col items-center gap-6 desktop:mt-0 desktop:flex-row desktop:gap-14">
      <div className="w-full flex-1 desktop:w-auto">
        <Skeleton className="h-[48px]" />
      </div>
      <div className="w-full flex-1 desktop:w-auto">
        <Skeleton className="h-[48px]" />
      </div>
    </div>
  </div>
);
